export default __webpack_public_path__ + "static/media/potato-18.11a538e9.png";